import React from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import './cyberJumbo.css';

const CyberJumbo = (props) => {
  return (
    <div id='cyber-jumbo' className='pt-5'>
            <Container>
                <Row>
                    <Col>
                        <div className='cyber-jumbo-info'>
                            <h1 className='cj-title'>Cybersecurity Academy</h1>
                            <h3 className='cj-sub'>Expert-Led Training For Your Company</h3>
                            <p className='cj-bodytext'>This course is for individuals and teams sponsored by their company. Our Cybersecurity training equips your company’s individuals and teams with foundational knowledge of modern information security. Throughout the program, students will be trained in using various tools and receive certifications as well. With this important skill set, there will be an increase in the value of your employees.
                            </p>
                            <Row className=''>
                                {/* <Col xs={{ size: 6}} sm={{ size: 4}} md={{ size: 5}} className='pr-1'>
                                    <Button className='course-hero-start1 w-100 px-1'>Sign Up Now</Button>
                                </Col> */}
                                {/* <Col xs={{ size: 6}} sm={{ size: 4}} md={{ size: 5}} className='px-1'>
                                    <Button className='course-hero-apply1 w-100 px-1'>Request a Quote</Button>
                                </Col> */}
                            </Row>
                        </div>
                    </Col>
                </Row>
                
            </Container>
            
        </div>
  );
}

export default CyberJumbo;
